/**
 * LocationAnnouncer
 *
 * Screen reader announcements for location changes.
 * Uses aria-live region to announce when the user navigates to a new location.
 */

import React, { useEffect, useState } from 'react';
import { useSpatialNavigation } from '../../../hooks/useSpatialNavigation';
import { getLocationConfig } from '../../../config/locationConfig';

export interface LocationAnnouncerProps {
  /** Whether announcements are enabled */
  enabled?: boolean;
}

export const LocationAnnouncer: React.FC<LocationAnnouncerProps> = ({
  enabled = true,
}) => {
  const { currentLocation } = useSpatialNavigation();
  const [announcement, setAnnouncement] = useState('');

  useEffect(() => {
    if (!enabled) return;

    const config = getLocationConfig(currentLocation);
    setAnnouncement(`Navigated to ${config.name}. ${config.description}`);
  }, [currentLocation, enabled]);

  if (!enabled) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className="sr-only"
      data-testid="location-announcer"
    >
      {announcement}
    </div>
  );
};

export default LocationAnnouncer;
